import React, { Component, } from 'react';
import { Route, Switch, } from 'react-router-dom';
import { object, string, func, } from 'prop-types';
import { connect, } from 'react-redux';
import keys from 'lodash/keys';
import { Helmet, } from 'react-helmet';

import TabBar from '../../components/TabBar';
import fetchPageApi from './actions/fetchPageApi';
import Panel from './components/Panel';

export class SymbolSummary extends Component {
  static propTypes = {
    fetchPageApi: func.isRequired,
    match: object.isRequired,
    history: object.isRequired,
    token: string.isRequired,
    company: string.isRequired,
    symbolSummary: object,
  }
  static defaultProps = {
    symbolSummary: {},
  }
  constructor(props) {
    super(props);
    this.state = {
      initTab: false,
      activeInterval: 0,
    };
  }
  componentDidMount() {
    const {
      match,
      fetchPageApi,
      token,
      symbolSummary,
      company,
    } = this.props;
    const {
      year,
      month,
    } = match.params;
    if (!symbolSummary[year] || !symbolSummary[year][month]) {
      fetchPageApi(company, year, month, token);
    }
  }
  render() {
    const { symbolSummary, match, } = this.props;
    const { projectId, year, month, } = match.params;
    if (!symbolSummary[year] || !symbolSummary[year][month]) {
      return null;
    }
    const symbolSummaryData = symbolSummary[year][month];
    const tabs = ['rr5', 'rr4', 'rr3'].map(tab => ({
      name: tab.toUpperCase(),
      url: `${year}/${month}/symbol-summary/${tab}`,
      key: tab,
    }));
    const intervals = [
      { name: '1M', args: [0], },
      { name: '3M', args: [1], },
      { name: '6M', args: [2], },
      { name: '1Y', args: [3], },
      { name: 'YTM', args: [4], },
    ];
    if (!this.state.initTab) {
      this.props.history.replace(`/${projectId}/${tabs[0].url}`);
      this.setState({ initTab: true, });
    }
    return (
      <div>
        <Helmet>
          <title>月報-個別標的總覽</title>
        </Helmet>
        <div style={ { position: 'fixed', zIndex: 1, } }>
          <TabBar tabs={ tabs } />
          <TabBar
            tabs={ intervals }
            handleClick={ idx => this.setState({ activeInterval: idx, }) }
            activeTabName={ intervals[this.state.activeInterval].name }
          />
        </div>
        <div className="placeholder" style={ { height: 60, } } />
        <Switch>
          {
            keys(symbolSummaryData).map(report => (
              <Route
                key={ report }
                path={ `/${projectId}/${year}/${month}/symbol-summary/${report}` }
                render={
                  () => (
                    <Panel
                      report={ report }
                      year={ year }
                      month={ month }
                      projectId={ projectId }
                      interval={ intervals[this.state.activeInterval].name }
                    />
                  )
                }
              />
            ))
          }
        </Switch>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    symbolSummary: state.symbolSummary,
    token: state.appState.userToken,
    company: state.appState.company,
  };
}

const dispatchObj = {
  fetchPageApi,
};

export default connect(mapStateToProps, dispatchObj)(SymbolSummary);



// WEBPACK FOOTER //
// ./src/scenes/SymbolSummary/index.js